<template>
  <div class="box-sign-up">
    <h2 class="login-title" v-if="this.routeName != 'GiftCard'">Dropsmart Trial Sign Up</h2>
    <!--div v-if="this.routeName == 'GiftCard'">
    <h2 style="font-weight: 700; font-size: 1.8rem; margin-top: 0;">Activate your gift card below</h2>
    </div-->
    <p>{{user.firstName}}, you're just a couple of clicks away from becoming a Dropsmarter officially! 😃</p>
    <p>To provide you with a superb customized experience suitable to your profile - we would like to know more about you!</p>
    <p>Your personal information is strictly confidential and safe, as we will never sell it or share it with third parties.</p>
    <br/>

    <b-form
      style="text-align: left; max-width: 30em;"
      aria-autocomplete="off"
      @submit.prevent="submitSignup"
    >

      <!-- REVIEW THE NUMBER f1943 --
      <div v-if="this.routeName == 'GiftCard'">
          <b-form-group  label="Who gifted you with 3 months of Dropsmart?" label-for="f1943" >
          <b-form-input
            ref="whoGiftedInput"
            name="f1943"
            v-model="$v.form.f1943.$model"
            :state="validateInput('f1943')"
            class="LoginInput"
            size="lg"
            placeholder="Who Gifted You"
            aria-describedby="f1943-feedback"
            id="f1943"
          ></b-form-input>
          <b-form-invalid-feedback id="f1943-feedback" v-bind:tooltip="false"
            >This is a required field.</b-form-invalid-feedback
          >
        </b-form-group>
      </div-->

      <b-form-group label="Your country of origin:" label-for="country" :state="validateInput('country')" :invalid-feedback="fieldRequired">
        <b-form-select id="country" v-model="$v.form.country.$model" size="lg" :options="countries" class="choice-selector"
         :state="validateInput('country')"> </b-form-select>
      </b-form-group>
      
      <b-form-group  label="Your Profession/Occupation:" label-for="ds_profession">
        <b-form-input
          ref="favoriteOilsInput"
          name="ds_profession"
          v-model="$v.form.ds_profession.$model"
          :state="validateInput('ds_profession')"
          class="LoginInput"
          size="lg"
          placeholder="Your Profession/Occupation"
          aria-describedby="ds_profession-feedback"
          id="ds_profession"
        ></b-form-input>
        <b-form-invalid-feedback id="ds_profession-feedback" v-bind:tooltip="false"
          >This is a required field.</b-form-invalid-feedback
        >
      </b-form-group>
      
      <b-form-group label="How long have you been using aromatherapy in your practice?" label-for="ds_how_long_using_aromatherapy"
       :state="validateInput('ds_how_long_using_aromatherapy')" :invalid-feedback="fieldRequired">
        <b-form-select id="ds_how_long_using_aromatherapy" v-model="$v.form.ds_how_long_using_aromatherapy.$model" size="lg" :options="experienceLevels" class="choice-selector"
         :state="validateInput('ds_how_long_using_aromatherapy')"> </b-form-select>
      </b-form-group>
      
      <b-form-group label="How many essential oils bottles do you own?" label-for="ds_number_of_essential_oils_bottles"
       :state="validateInput('ds_number_of_essential_oils_bottles')" :invalid-feedback="fieldRequired">
        <b-form-select id="ds_number_of_essential_oils_bottles" v-model="$v.form.ds_number_of_essential_oils_bottles.$model" size="lg" :options="numberOfBottles" class="choice-selector"
         :state="validateInput('ds_number_of_essential_oils_bottles')"> </b-form-select>
      </b-form-group>
      
      <b-form-group label="How much do you spend on essential oils per month?" label-for="ds_monthly_expenses_on_essential_oils"
       :state="validateInput('ds_monthly_expenses_on_essential_oils')" :invalid-feedback="fieldRequired">
        <b-form-select id="ds_monthly_expenses_on_essential_oils" v-model="$v.form.ds_monthly_expenses_on_essential_oils.$model" size="lg" :options="monthlyExpenditures" class="choice-selector"
         :state="validateInput('ds_monthly_expenses_on_essential_oils')"> </b-form-select>
      </b-form-group>
      
      <b-form-group label="Your Educational Level:" label-for="educationLevels"
       :state="validateInput('ds_educational_level')" :invalid-feedback="fieldRequired">
        <b-form-select id="ds_educational_level" v-model="$v.form.ds_educational_level.$model" size="lg" :options="educationLevels" class="choice-selector"
         :state="validateInput('ds_educational_level')"> </b-form-select>
      </b-form-group>
            
      <b-form-group label="Employment Status:" label-for="occupationTypes"
       :state="validateInput('ds_employment_status')" :invalid-feedback="fieldRequired">
        <b-form-select id="ds_employment_status" v-model="$v.form.ds_employment_status.$model" size="lg" :options="occupationTypes" class="choice-selector"
         :state="validateInput('ds_employment_status')"> </b-form-select>
      </b-form-group>
            
      <b-form-group  label="What are your 5 favorite essential oils?" label-for="ds_5_favorite_essential_oils">
        <b-form-input
          ref="favoriteOilsInput"
          name="ds_5_favorite_essential_oils"
          v-model="$v.form.ds_5_favorite_essential_oils.$model"
          :state="validateInput('ds_5_favorite_essential_oils')"
          class="LoginInput"
          size="lg"
          placeholder="Favorite Oils"
          aria-describedby="ds_5_favorite_essential_oils-feedback"
          id="ds_5_favorite_essential_oils"
        ></b-form-input>
        <b-form-invalid-feedback id="ds_5_favorite_essential_oils-feedback" v-bind:tooltip="false"
          >This is a required field.</b-form-invalid-feedback
        >
      </b-form-group>

      <button class="button-login" type="submit" id="submitLogin">
        <b-spinner v-show="showLoad"></b-spinner>
        <span class id="button-text" v-if="!showLoad">Confirm</span>
      </button>
    </b-form>
    
    <!--StandardLeft style="margin-top: 2rem;" :routeName="routeName" v-if="this.routeName == 'GiftCard'"/-->

  </div>
</template>

<script>
import { BACKEND_URL, FRONTEND_URL } from "../config.js";

import { countriesTrialPage } from "@/utils/countries.js";

import { validationMixin } from "vuelidate";

import { required, /*minLength, email, sameAs*/ } from "vuelidate/lib/validators";


export default {
  props: ['routeName', 'user', 'token', 'period'],
  mixins: validationMixin,
  validations: {
    form: {
      country: {required},
      ds_profession: {required},
      ds_how_long_using_aromatherapy: {required},
      ds_number_of_essential_oils_bottles: {required},
      ds_monthly_expenses_on_essential_oils: {required},
      ds_educational_level: {required},
      ds_employment_status: {required},
      ds_5_favorite_essential_oils: {required},
    },
  },
  computed: {
    validForm() {
      return !this.$v.form.$anyError;
    },
  },
  data() {
    return {
      fieldRequired: 'This answer is required.',
      emailIsRegistered: false,
      showLoad: false,
      termsAndConditionsUrl: BACKEND_URL.TermsAndConditions,
      dsAppUrl: FRONTEND_URL.AppLoginPage,
      countries: countriesTrialPage,
      professions: [
        'Chemist',
        'Chiropractic',
        'Functional Medicine Practitioner/Physician',
        'General Practitioner',
        'Aromatherapy Educator',
        'Massage Therapist',
        'Natural Health Coach',
        'Naturopath',
        'Nurse',
        'Pharmacist',
        'Physician/Medical Doctor',
        'Physiotherapist',
        'Psychologist',
        'Psychotherapist',
        'Reflexologist',
        'Other',
      ],
      experienceLevels: [
        'I\'m not using it yet, I\'m studying',
        '0-1 year',
        '1-5 years',
        '5-10 years',
        '10-15 years',
        '15-20 years',
        'More than 20 years',
      ],
      numberOfBottles: [
        '1 to 20',
        '20 to 30',
        '30 to 50',
        '50 to 70',
        '70 to 100',
        'More than 100',
      ],
      monthlyExpenditures: [
        '0 to 10 USD',
        '10 to 30 USD',
        '30 to 50 USD',
        '50 to 70 USD',
        '70 to 100 USD',
        '100 to 150 USD',
        '150 to 200 USD',
        'More than 200 USD',
      ],
      educationLevels: [
        'High school',
        'Bachelor',
        'Master',
        'Doctorate',
        'PhD',
        'I don\'t feel comfortable disclosing that',
      ],
      occupationTypes: [
        'Self-employed',
        'Business Owner (2 or more people)',
        'I work for a third-party company',
        'Unemployed',
        'Retired',
        'I don\'t feel comfortable disclosing that',
      ],
      form: {
        email: this.user.email,
        country: null,
        ds_profession: null,
        ds_how_long_using_aromatherapy: null,
        ds_number_of_essential_oils_bottles: null,
        ds_monthly_expenses_on_essential_oils: null,
        ds_educational_level: null,
        ds_employment_status: null,
        ds_5_favorite_essential_oils: null,
      },
      trialId: 40,
    };
  },
  methods: {
    // method to validate the field for GiftCard (not applicable anymore)
    f1943Check() {
      if(this.routeName != "GiftCard") {
          return this.form.f1943 = "not applied";
      } else {
          return this.form.f1943; 
      }
    },
    submitSignup() {
      // this.f1943Check();
      this.$v.form.$touch();
      if (!this.validForm) {
        return;
      }
      this.formDisabled = true;
      this.showLoad = true;

      let formData = new FormData();
      Object.keys(this.form).forEach(k => formData.append(k, this.form[k]));

      let postUrl = BACKEND_URL.TrialSignup + '?trialId=' + this.trialId + "&trialDays=" + this.period;
      fetch(postUrl, {
        method: "POST",
        mode: "cors",
        body: formData,
        headers: {
          "Authorization": this.token 
        },
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            if (response.status == 409) {
              console.log("Email already exists");
            }
            throw Error(response.status + ": " + response.statusText);
          }
        })
        .then(trialData => {
          this.$parent.$emit('TrialAccountCreated', trialData);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.showLoad = false;
        });
    },
    checkEmail() {
      if (!this.form.email) {
        return;
      }
      let url = BACKEND_URL.CheckEmail + "?email=" + this.form.email;
      console.log("checking " + url);
      fetch(url, {
        method: "GET",
        mode: "cors",
      })
        .then((response) => {
          if (response.ok || response.status == 204) {
            this.emailIsRegistered = response.status != 204;
          } else {
            throw Error(response.status + " " + response.statusText);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    validateInput(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
  mounted() {
    this.emailIsRegistered = false;
    this.$v.form.$reset();
    this.$v.$reset();
  },
};
</script>

<style lang="scss">
</style>